import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ChefHat } from 'lucide-react'
import toast from 'react-hot-toast'

const API = import.meta.env.VITE_API_URL || ''

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setLoading(true)
    try {
      await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      setSent(true)
    } catch {
      toast.error('Hiba történt, próbáld újra')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#F0FAF7' }}>
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: '#5BB8A0' }}>
            <ChefHat className="w-5 h-5 text-white" />
          </div>
          <span className="font-bold text-lg" style={{ color: '#1E2D27' }}>CukrászDoc</span>
        </div>

        {sent ? (
          <div className="text-center">
            <div className="text-4xl mb-4">📧</div>
            <h1 className="text-xl font-bold mb-2" style={{ color: '#1E2D27' }}>Email elküldve!</h1>
            <p className="text-sm text-gray-500 mb-6">
              Ha ez az email cím regisztrált, küldtünk egy visszaállító linket. Nézd meg a Spam mappát is.
            </p>
            <Link to="/login" className="text-sm font-semibold hover:underline" style={{ color: '#5BB8A0' }}>
              Vissza a bejelentkezéshez
            </Link>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold mb-1" style={{ color: '#1E2D27' }}>Elfelejtett jelszó</h1>
            <p className="text-sm text-gray-500 mb-8">Add meg az email címed, küldünk egy visszaállító linket.</p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="label">E-mail cím</label>
                <input
                  className="input"
                  type="email"
                  placeholder="nev@email.hu"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full">
                {loading ? 'Küldés...' : 'Link küldése'}
              </button>
            </form>

            <p className="text-sm text-center text-gray-400 mt-6">
              <Link to="/login" className="font-semibold hover:underline" style={{ color: '#5BB8A0' }}>
                Vissza a bejelentkezéshez
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  )
}
